import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class CardCarousel {
    /**
     * Card Carousel - configurable slides per view based on layout
     * Reads data-desktop-slides from parent section (2 for side-by-side, 3 or 4 for stacked)
     * Mobile: always 1 slide
     */
    constructor(sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.swiperEl = this.sliderElement.querySelector('.swiper') || this.sliderElement;
        this.sectionWrapper = this.sliderElement.closest('[data-desktop-slides]');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.init();
    }

    init() {
        const desktopSlides = this.sectionWrapper
            ? parseInt(this.sectionWrapper.dataset.desktopSlides, 10)
            : 2;

        new Swiper(this.swiperEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: desktopSlides
                }
            }
        });
    }
}
